"use client"

import { useEffect } from "react"

export function TawkToChat() {
  useEffect(() => {
    // Tawk.to script
    const s1 = document.createElement("script")
    const s0 = document.getElementsByTagName("script")[0]

    s1.async = true
    s1.src = "https://embed.tawk.to/67f4d9f39b5f671906ebc1e1/1ioa76obn"
    s1.charset = "UTF-8"
    s1.setAttribute("crossorigin", "*")

    if (s0 && s0.parentNode) {
      s0.parentNode.insertBefore(s1, s0)
    } else {
      document.head.appendChild(s1)
    }

    // Cleanup function
    return () => {
      // Remove the script when component unmounts
      const tawkScript = document.querySelector(
        'script[src="https://embed.tawk.to/67f4d9f39b5f671906ebc1e1/1ioa76obn"]',
      )
      if (tawkScript && tawkScript.parentNode) {
        tawkScript.parentNode.removeChild(tawkScript)
      }

      // Remove any Tawk.to elements that might have been added to the DOM
      const tawkElements = document.querySelectorAll('[class^="tawk-"]')
      tawkElements.forEach((element) => {
        if (element.parentNode) {
          element.parentNode.removeChild(element)
        }
      })
    }
  }, [])

  return null // This component doesn't render anything visible
}
